// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","info":"Footer_info__3yXvo","info__sub":"Footer_info__sub__KNkAU","contact":"Footer_contact__8nNuz"};